import { createSelector } from 'reselect'

const getUserLogged = state => state.user.logged
const getUI = state => state.ui

const storeBaseRouteSelector = createSelector(
	[ getUserLogged, getUI ],
	(userLogged, uiData) => {
		const isReadyToRender = userLogged !== null

		return {
			isReadyToRender,
			isLoggedUser: userLogged,
			viewType: uiData.currentView,
		}
	}
)

export default storeBaseRouteSelector
